import React from "react";
import { Alert, Chip, Stack, Tooltip } from "@mui/material";
import { RECEPTION_COLORS, RECEPTION_LABELS } from "./constants";

// Los tres contadores de la cabecera, que ademas son los filtros.
//
// Existen porque sin ellos la pantalla no dice en ningun lado cuanto trabajo hay: se entra, se
// ve una pared de "sin documento" -que en Grupo DK son el 57% de las entregas- y parece que el
// modulo no anda. El numero de "por firmar" es el que contesta esa pregunta.
//
// Los contadores se calculan sobre los filtros vigentes menos el de estado, asi que sirven para
// saltar de un estado a otro sin perder el periodo que se estaba mirando.
const ORDER = ["pending", "signed", "missing"];

const DocumentsSummary = ({ counts, active, onSelect, health }) => {
    if (!counts) return null;

    return (
        <Stack spacing={1.5} sx={{ mb: 2 }}>
            <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", gap: 1 }}>
                {ORDER.map((status) => {
                    const isActive = active === status;
                    return (
                        <Chip
                            key={status}
                            label={`${(counts[status] ?? 0).toLocaleString("es-CL")} ${RECEPTION_LABELS[status].toLowerCase()}`}
                            color={RECEPTION_COLORS[status]}
                            variant={isActive ? "filled" : "outlined"}
                            onClick={() => onSelect(isActive ? "" : status)}
                            sx={{ cursor: "pointer", fontWeight: isActive ? 600 : 400 }}
                        />
                    );
                })}
            </Stack>

            {/* Solo aparece cuando hay algo que hacer. Distingue un problema del negocio -falta
                la firma- de uno del sistema -el documento existe pero no se genero la copia-,
                que es justo lo que la tabla no sabe explicar por si sola. */}
            {health?.sin_copia_generada > 0 && (
                <Alert severity="info" sx={{ py: 0.25 }}>
                    <Tooltip title="Se generan solas cuando llega un documento nuevo. Para las anteriores hay que correr el backfill.">
                        <span>
                            {health.sin_copia_generada.toLocaleString("es-CL")} entregas tienen factura o guía del ERP
                            pero todavía no se les genera la copia para firmar
                            {health.firmadas_sin_pod > 0 && (
                                <>, y {health.firmadas_sin_pod.toLocaleString("es-CL")} ya están firmadas y esperan su P.O.D.</>
                            )}
                            .
                        </span>
                    </Tooltip>
                </Alert>
            )}

            {health?.parciales_sin_regularizar > 0 && (
                <Alert severity="warning" sx={{ py: 0.25 }}>
                    {health.parciales_sin_regularizar.toLocaleString("es-CL")} entregas parciales sin regularizar:
                    se recibió menos de lo que dice el documento y falta anotar con qué se cuadró.
                </Alert>
            )}
        </Stack>
    );
};

export default DocumentsSummary;
